// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 8599 ? "Gallery" : chunkId) + "." + {"7025":"e19a29d2","7734":"84cbc9ab","8599":"0a8cf3c4"}[chunkId] + ".chunk.css";
};